import { render } from "./DocumentCategories.vue?vue&type=template&id=1b9defa5"
import script from "./DocumentCategories.vue?vue&type=script&lang=ts"
export * from "./DocumentCategories.vue?vue&type=script&lang=ts"
script.render = render

export default script